// extracted by mini-css-extract-plugin
export default {"head":"FiatAndSpot_head__LRDxD","body":"FiatAndSpot_body__qD58C","button":"FiatAndSpot_button__W7jRh"};